import React from 'react'
import { Checkbox } from '../ui/checkbox'

const JoinUs = () => {
  return (
    <div className='mt-24 '>
    
    </div>
  )
}

export default JoinUs